import {Injectable} from '@angular/core';
import {Settings} from '../../core';
import {MdlDialogService} from '@angular-mdl/core';
import {EQueryAttachmentDownloadLink} from '../models/e-query-attachment-download-link';
import {DL_LINKS_TOKEN, DownloadDialogComponent} from '../../shared/document-downloader/download-dialog.component';
import { ActivityLogger } from '../../activities/activity-logger';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class EQueryAttachmentsDownloader {
    constructor(
        private readonly dialogService: MdlDialogService,
        private readonly settings: Settings,
        private sanitizer: DomSanitizer,
        private readonly activityLogger: ActivityLogger
    ) {}

    public async downloadInvestigatorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        this.activityLogger.logActivity('Download Attachment');

        const dlLink = new EQueryAttachmentDownloadLink(false);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async previewInvestigatorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        const dlLink = new EQueryAttachmentDownloadLink(true);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async downloadSponsorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        this.activityLogger.logActivity('Download Attachment');

        const dlLink = new EQueryAttachmentDownloadLink(false);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async previewSponsorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        const dlLink = new EQueryAttachmentDownloadLink(true);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async downloadCoordinatorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        const dlLink = new EQueryAttachmentDownloadLink(false);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async previewCoordinatorAttachment(attachmentId: number, eQueryId: number): Promise<boolean> {
        const dlLink = new EQueryAttachmentDownloadLink(true);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadAttachmentUrl(attachmentId, eQueryId));
    }

    public async downloadResponseAttachment(attachmentId: number): Promise<boolean> {
        const dlLink = new EQueryAttachmentDownloadLink(false);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadResponseAttachmentUrl(attachmentId));
    }

    public async downloadResponseAttachmentWithTracking(attachmentId: number): Promise<boolean> {
        this.activityLogger.logActivity('Download Attachment');
        return await this.downloadResponseAttachment(attachmentId);
    }

    public async previewResponseAttachment(attachmentId: number): Promise<boolean> {

        const dlLink = new EQueryAttachmentDownloadLink(true);
        return await this.showDownloadingDialog(dlLink, this.createEQueryDownloadResponseAttachmentUrl(attachmentId));
    }

    private createEQueryDownloadAttachmentUrl(attachmentId: number, eQueryId: number): string {
        return `${this.settings.apiUrl}/e-queries/${eQueryId}/attachments/${attachmentId}`;
    }

    private createEQueryDownloadResponseAttachmentUrl(attachmentId: number): string {
        return `${this.settings.apiUrl}/e-queries/response-attachments/${attachmentId}`;
    }

    private async showDownloadingDialog(dlLink: EQueryAttachmentDownloadLink, url: string) {
        const mdlDialogReference = await this.dialogService
            .showCustomDialog({
                component: DownloadDialogComponent,
                providers: [{
                    provide: DL_LINKS_TOKEN,
                    useValue: {
                        url: url,
                        params: dlLink
                    }
                }],
                isModal: true
            })
            .toPromise();
        return await mdlDialogReference.onHide().toPromise<boolean>();
    }
}
